import './CommunityPlaceholder.scss'

import { useTranslation } from 'react-i18next'

import greyPin from '../../assets/images/common/icons/op36-location-pin-icon.svg'

const CommunityPlaceholder = () => {
  const { t } = useTranslation()

  return (
    <div id='CommunityPlaceholder'>
      <img src={greyPin} alt='pin' />

      <p className='mt-3'>
        {t('communityMap.placeholder.intro')}
      </p>
    </div>
  )
}

export default CommunityPlaceholder
